import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

const employmentTypes = [
  { value: 'fulltime', label: 'Full Time' },
  { value: 'parttime', label: 'Part Time' },
  { value: 'selfemployed', label: 'Self Emp.' },
  { value: 'benefit', label: 'Benefit' },
  { value: 'other', label: 'Other' },
];

const StepEmployment = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-[#00D47E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Briefcase className="w-7 h-7 text-[#00D47E]" />
        </div>
        <h2 className="font-outfit text-2xl md:text-3xl font-bold text-black mb-2">
          Employment Details
        </h2>
        <p className="text-gray-600">Tell us about your work</p>
      </div>

      <div className="space-y-4">
        <div>
          <Label className="text-gray-700 mb-3 block">Employment Type</Label>
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
            {employmentTypes.map(({ value, label }) => (
              <button
                key={value}
                onClick={() => handleChange('employment_type', value)}
                data-testid={`employment-type-${value}`}
                className={`p-3 rounded-lg border-2 text-xs font-medium transition-all ${
                  formData.employment_type === value
                    ? 'border-[#00D47E] bg-[#00D47E]/5 text-[#00D47E]'
                    : 'border-gray-200 hover:border-gray-300 text-gray-600'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {formData.employment_type && formData.employment_type !== 'benefit' && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-gray-700">Occupation</Label>
                <Input
                  value={formData.occupation}
                  onChange={(e) => handleChange('occupation', e.target.value)}
                  placeholder="e.g. Builder"
                  className="mt-2"
                  data-testid="occupation-input"
                />
              </div>
              <div>
                <Label className="text-gray-700">Employer Name</Label>
                <Input
                  value={formData.employer_name}
                  onChange={(e) => handleChange('employer_name', e.target.value)}
                  placeholder="Company name"
                  className="mt-2"
                  data-testid="employer-name-input"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-gray-700">Years Employed</Label>
                <Input
                  type="number"
                  value={formData.employment_duration_years}
                  onChange={(e) => handleChange('employment_duration_years', e.target.value)}
                  placeholder="2"
                  className="mt-2"
                  data-testid="employment-years-input"
                />
              </div>
              <div>
                <Label className="text-gray-700">Months</Label>
                <Input
                  type="number"
                  value={formData.employment_duration_months}
                  onChange={(e) => handleChange('employment_duration_months', e.target.value)}
                  placeholder="6"
                  className="mt-2"
                  data-testid="employment-months-input"
                />
              </div>
            </div>
          </motion.div>
        )}

        <div className="grid grid-cols-2 gap-4 pt-2 border-t border-gray-100">
          <div>
            <Label className="text-gray-700">Income Amount</Label>
            <div className="mt-2 relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
              <Input
                type="number"
                value={formData.income_amount}
                onChange={(e) => handleChange('income_amount', e.target.value)}
                className="pl-7"
                placeholder="1200"
                data-testid="income-amount-input"
              />
            </div>
          </div>
          <div>
            <Label className="text-gray-700">Frequency</Label>
            <Select
              value={formData.income_frequency}
              onValueChange={(value) => handleChange('income_frequency', value)}
            >
              <SelectTrigger className="mt-2" data-testid="income-frequency-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="weekly">Weekly</SelectItem>
                <SelectItem value="fortnightly">Fortnightly</SelectItem>
                <SelectItem value="monthly">Monthly</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepEmployment;
